/* eslint-disable react/react-in-jsx-scope */
import { Box } from "@mui/material";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import { Editor } from "@tinymce/tinymce-react";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";

type Props = {
  closed: () => void;
  open: boolean;
  selectedData?: any;
  title?: string;
  drawerWidth?: number;
};

export default function CommonShowNotes({ closed, selectedData, open, title,drawerWidth}: Props) {
   const { height } = UseWindowDimensions();
  return (
    <>
      <CommonDrawer
        heading={title || "Notes"}
        isOpen={open}
        closeDrawer={() => {
          closed && closed();
        }}
        drawerWidth={drawerWidth || 600}
      >
        <Box mt={1.5}>
          <Editor
            tinymceScriptSrc="/tinymce/tinymce.min.js"
            value={selectedData}
            disabled={true}
            scriptLoading={{ async: true, delay: 5 }}
            init={{
              height: height - 140,
              toolbar: "",
              menubar: false,
              licenseKey: "gpl",
            }}
          />
        </Box>
      </CommonDrawer>
    </>
  );
}
